import React from "react";
import { Link } from "react-router-dom";
import backimg from "../../../assets/solutions-images/hero_ban_itasset.webp";
import "../solution.css";

const ItAsset = () => {
  return (
    <>
      {/* Hero Section */}
      <div>
        <div
          className="bg-cover bg-center bg-no-repeat min-h-[400px] md:min-h-[502px] flex flex-col gap-6 md:gap-8 justify-center px-4 py-12 md:px-8 lg:px-16 hover_herosec"
          style={{ backgroundImage: `url(${backimg})` }}
        >
          <h1
            style={{ wordSpacing: "8px" }}
            data-aos="fade-down"
            className="text-2xl md:text-3xl lg:text-5xl font-semibold text-white w-full sm:w-full md:w-2/3 lg:w-[680px]"
          >
            Optimize Spending and Resource Allocation
          </h1>
          <p className="text-white text-sm md:text-base w-full md:w-2/3 lg:w-[732px]" data-aos="fade-down">
            We help businesses optimize ROI by harnessing the power of ServiceNow ITAM. With our expertise, you can streamline IT asset management, reduce costs, and gain full visibility across the IT lifecycle.
          </p>
          <Link
            data-aos="zoom-in"
            data-aos-delay="300"
            to="/contact-us"
            className="w-fit bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white hover:bg-white hover:text-[#C32A7C] transition-colors duration-400 ease-in-out text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
          >
            Contact Us
          </Link>
        </div>
      </div>


      <div className="bg-[#FFFFFF] mt-6 mb-10">
        <div className="flex flex-col sm:justify-center text-center items-center gap-4 py-8 px-4">
          <h1 className="text-[#1A5298] font-bold text-xl md:text-3xl">
            What can we help you achieve with ITAM solutions by ServiceNow?
          </h1>
        </div>

        <div className="bg-white">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-8 px-4 md:px-10 lg:px-10 py-5 items-start">
            {[
              {
                title: "Mitigate Technology Risks",
                description:
                  "Tackle challenges such as technical debt, shadow IT, vulnerabilities, license compliance, and lost assets with urgency and precision.",
              },
              {
                title: "Reduce Unnecessary Costs",
                description:
                  "Gain a clear overview of your IT assets and expenditures to swiftly identify areas of overspending and efficiently control shadow IT expenses.",
              },
              {
                title: "Streamline Asset Lifecycles",
                description:
                  "Streamline asset workflows throughout their lifecycle and proactively assess asset lifecycles to identify and address requirements.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center justify-center lined_hoverset" data-aos="zoom-in-up"
              >
                <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold w-full md:w-[253px] text-center">
                  {item.title}
                </h2>
                <div className="mt-2 flex flex-col items-center md:w-40">
                  <img
                    className="object-contain my-5"
                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                    alt="Enhance IT Workflows"
                  />
                </div>
                <p className="text-sm md:text-base text-black max-w-[352px]">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-[#F4F4F4] w-full py-10 md:py-12">
        <div className="flex flex-col items-center text-center px-4 md:px-6">
          <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-5 w-full"data-aos="fade-down">
            Our ServiceNow ITAM Expertise
          </h1>
          <h5 className="text-md text-black font-medium text-center"data-aos="fade-up">
            Cloud Cost Management | Hardware Asset Management | SaaS License Management | Software Asset Management
          </h5>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="bg-[#FFFFFF] w-full py-10 md:py-12">
        <div className="flex flex-col items-center text-center px-4 md:px-6" data-aos="fade-down-right">
          <h1 className="line_heightsests text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-[800px] lg:w-[800px]">
            Boost your ServiceNow ITAM capabilities with Tekpossible's advanced solutions.
          </h1>
          <Link
            data-aos="zoom-in"
            data-aos-delay="300"
            to={"/contact-us"}
            className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </>
  );
};

export default ItAsset;